import PropTypes from "prop-types"
import { useCallback } from "react"
import { connect } from "react-redux"

import api from "apis"
import { setBoxDesigns } from "areas/product/store/actions"

export default function fetchBoxDesigns(WrappedComponent) {
  const InternalFetchBoxDesigns = (props) => {
    const { boxDesigns, setBoxDesigns } = props

    const afterShow = useCallback(async () => {
      if (!boxDesigns.length) {
        try {
          const result = await api.get("/api/v10/products/load_box_designs")
          if (result && result.data && result.data.length != 0) {
            setBoxDesigns(result.data)
          } else {
            throw new Error("Error on getBoxDesigns")
          }
        } catch (error) {
          console.error(error)
        }
      }
    }, [boxDesigns])

    return <WrappedComponent afterShow={afterShow} {...props} />
  }

  InternalFetchBoxDesigns.propTypes = {
    boxDesigns: PropTypes.array,
    designBoxTitle: PropTypes.string,
    setBoxDesigns: PropTypes.func,
  }

  const mapStateToProps = (state) => {
    return {
      boxDesigns: state.boxDesigns,
      designBoxTitle: state.wizard.data?.box?.design?.title,
    }
  }

  const mapDispatchToProps = (dispatch) => ({
    setBoxDesigns: (boxDesigns) => dispatch(setBoxDesigns(boxDesigns)),
  })

  const FetchBoxDesigns = connect(
    mapStateToProps,
    mapDispatchToProps
  )(InternalFetchBoxDesigns)

  return FetchBoxDesigns
}
